import ApiCore from 'Services/API/Core';

export default ApiCore(process.env.REACT_APP_API_REGISTRY, {
  is_account_parent: true
});
